import React, { FC, MouseEventHandler, ReactNode } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';

export const PaymentOptionsGrid: FC = ({ children }) => {
  const classes = useStyles();
  return <Box className={classes.grid}>{children}</Box>;
};

interface PaymentOptionCellProps {
  label: string;
  checked?: boolean;
  disabled?: boolean;
  onToggle?: MouseEventHandler<HTMLButtonElement>;
  children?: ReactNode;
}

export const PaymentOptionCell: FC<PaymentOptionCellProps> = ({
  label,
  checked,
  disabled,
  onToggle,
  children,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.cell}>
      <Checkbox checked={checked} disabled={disabled} onClick={onToggle} />
      <Typography className={classes.label}>{label}</Typography>
      {children && <Box className={classes.input}>{children}</Box>}
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1, 3),
    marginTop: theme.spacing(1),
  },
  cell: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    flex: '0 0 auto',
    maxWidth: 100,
    lineHeight: 1.25,
  },
  input: {
    flex: '0 0 auto',
    width: 130,
    marginLeft: theme.spacing(1.5),
    '& .MuiInputLabel-root': {
      whiteSpace: 'nowrap',
    },
  },
}));
